// extracted by mini-css-extract-plugin
export default {"dropIndicator":"DropIndicator_dropIndicator__4mXqO"};